import * as React from 'react'

import { Title } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { SchoolPage_school_director_achievements } from '../gql'
import { i18nKeyPrefix } from '../i18n'
import Achievement from './Achievement'
import { AchievementContainer, AchievementsContainer } from './Achievements.styles'
import manifest from './manifest'
import { filterOtherEducationItems, filterSpecialCertificationItems } from './util'

const PRE = `${i18nKeyPrefix}-ACHIEVEMENTS`

interface IProps {
  achievements: SchoolPage_school_director_achievements
}

export default function Achievements(props: IProps) {
  const {
    achievements: {
      educationLevel,
      infantToddlerExperience,
      otherEducationItems,
      preschoolExperience,
      schoolExperience,
      specialCertificationItems,
    },
  } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <div>
      <Title kind="large">{t(`${PRE}-TITLE`)}</Title>
      <AchievementsContainer>
        {infantToddlerExperience && (
          <AchievementContainer>
            <Achievement
              label={t(`${PRE}-INFANT-TODDLER`)}
              imageUrl={manifest.infantToddler.imageUrls[infantToddlerExperience]}
            />
          </AchievementContainer>
        )}
        {preschoolExperience && (
          <AchievementContainer>
            <Achievement
              label={t(`${PRE}-PRESCHOOL`)}
              imageUrl={manifest.preschool.imageUrls[preschoolExperience]}
            />
          </AchievementContainer>
        )}
        {schoolExperience && (
          <AchievementContainer>
            <Achievement
              label={t(`${PRE}-SCHOOL`)}
              imageUrl={manifest.school.imageUrls[schoolExperience]}
            />
          </AchievementContainer>
        )}
        {educationLevel && (
          <AchievementContainer>
            <Achievement
              label={t(`${PRE}-EDUCATION`)}
              imageUrl={manifest.education.imageUrls[educationLevel]}
            />
          </AchievementContainer>
        )}
        {otherEducationItems &&
          filterOtherEducationItems(otherEducationItems).map((item, i) => (
            <AchievementContainer key={i}>
              <Achievement
                label={
                  item.name ? t(`${PRE}-DEGREE`, { name: item.name }) : t(`${PRE}-DEGREE-NO-NAME`)
                }
                imageUrl={manifest.education.imageUrls[item.level]}
              />
            </AchievementContainer>
          ))}
        {specialCertificationItems &&
          filterSpecialCertificationItems(specialCertificationItems).map((item, i) => (
            <AchievementContainer key={i}>
              <Achievement
                label={item.name}
                imageUrl={
                  manifest.specialCertifications.imageUrls[
                    i % manifest.specialCertifications.imageUrls.length
                  ]
                }
              />
            </AchievementContainer>
          ))}
      </AchievementsContainer>
    </div>
  )
}
